<script setup lang="ts">
const route = useRoute();
</script>

<template>
  <div class=" w-dvw h-dvh">
    <div class="bg-blue-100 h-10">
      test page {{ String(route.name).split('-').splice(1).join(' ').toUpperCase() }}
    </div>
    <div class="bg-gray-100">
      <NuxtPage />
    </div>
  </div>
</template>

<style scoped>

</style>
